<template>
  <SelectPickerMultiple
    v-model="selected"
    api-value="/api/languages/search?query="
    :placeholder-value="placeholderValue"
    :label="label"
  />
</template>

<script setup>
import {ref, watch} from 'vue';
import SelectPickerMultiple from '@/ComponentsDeprecated/Select/SelectPickerMultiple';

const props = defineProps({
  modelValue: {
    type: Array,
    required: false,
    default: [],
  },
  placeholderValue: {
    type: String,
    required: false,
    default: 'Select Languages',
  },
  label: {
    type: String,
    required: false,
    default: 'Select Languages',
  },
});

const emit = defineEmits({ update: (_value) => true });
const selected = ref(props.modelValue);

watch(selected, () => {
  emit('update:modelValue', selected.value);
});

</script>
